__webpack_require__.p = "https://jako-wc.hosting.jfnet.de/";